import Image from 'next/image';

const LINK_URL_ON_LINE = 'https://lin.ee/XGRXJPl';
const LINE_IMAGE_SRC = 'https://scdn.line-apps.com/n/line_add_friends/btn/ja.png';

const InternalBlogLINERow = () => (
  <a href={LINK_URL_ON_LINE} target="_blank" rel="noreferrer">
    <Image src={LINE_IMAGE_SRC} alt="友だち追加" height={36} width={116} />
  </a>
);
export { InternalBlogLINERow };
